import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import './notices.sass';
import { NOTICE_SUCCESS_TYPE } from '../redux/actions/notices';

export default function FlashNotice(props) {
  const { notice, fadeOutNotice } = props;

  if (!notice) {
    return null;
  }

  const { title, body, type = NOTICE_SUCCESS_TYPE } = notice;

  const noticeClass = classNames({
    'flash-notice': true,
    [`notice-${type.toLowerCase()}`]: true,
    'fade-active': fadeOutNotice,
  });

  const titleClass = classNames({
    'notice-title': true,
    'with-body': body,
  });

  return (
    <div className={noticeClass}>
      <div className="notice-text">
        <If condition={title}>
          <span className={titleClass}>{title}</span>
        </If>
        <span
          className="notice-body"
          // eslint-disable-next-line
          dangerouslySetInnerHTML={{ __html: body }}
        />
      </div>
    </div>
  );
}

FlashNotice.propTypes = {
  notice: PropTypes.shape({
    title: PropTypes.string,
    body: PropTypes.string.isRequired,
    type: PropTypes.string,
    noticeDuration: PropTypes.number,
  }),
  fadeOutNotice: PropTypes.bool,
};
